// import React, { lazy } from 'react';
// import { Navigate, useRoutes } from 'react-router-dom';
// import Login from '../../pages/auth/Login';
// import Logout from '../../pages/auth/Logout';
// import NotFound from '../../pages/not_found/NotFound';
// import Home from '../../pages/globalWrapper/GlobalWrapper';

// // Admin Dashboard
// const AdminPagesWarper = lazy(() => import('../../pages/admin/PagesWarper'));
// const AdminHome = lazy(() => import('../../pages/admin/home/AdminHome'));
// const ResetWorkShops = lazy(() => import('../../pages/admin/resetWorkShops/ResetWorkShops'));
// // const Password = lazy(() => import('../../pages/admin/password/Password'));
// const ExportData = lazy(() => import('../../pages/admin/exportData/ExportData'));
// const ImportData = lazy(() => import('../../pages/admin/importData/ImportData'));

// // ServeAsthma Room
// const ServeAsthmaPagesWarper = lazy(() => import('../../pages/workshop/PagesWarper'));
// const ServeAsthmaHome = lazy(() => import('../../pages/workshop/workshopHome/WorkshopHome'));

// const WorkshopCore = lazy(() =>
//   import('../../pages/workshop/workshopCore/WorkshopCore')
// );
// const Routes = () => {
//   let currentPage = 'login';
//   const strUser = localStorage.getItem('user');
//   if (!strUser) {
//     currentPage = 'login';
//   } else {
//     const user = JSON.parse(localStorage.getItem('user'));
//     if (user?.is_admin) currentPage = 'admin';
//     else currentPage = 'home';
//   }
//   console.log(currentPage)
//   return useRoutes([
//     {
//       path: '/',
//       element: currentPage === 'login' ? <Navigate to="/login" /> : <Home />,
//       children: [
//         {
//           path: 'home',
//           element: currentPage === 'home' ? (<ServeAsthmaPagesWarper />) : (<Navigate to={`/${currentPage}`} />),
//           children: [
//             { path: '', element: <ServeAsthmaHome /> },
//             {
//               path: 'workshop',
//               element: <WorkshopCore />  ,
            
//             },
//           ],
//         },
//         {
//           path: 'admin',
//           element:
//           currentPage === 'admin' ? <AdminPagesWarper /> : <Navigate to={`/${currentPage}`} />,
//           children: [
//             { path: '', element: <AdminHome /> },
//             { path: 'reset', element: <ResetWorkShops /> },
//             { path: 'export', element: <ExportData /> },
//             { path: 'import', element: <ImportData /> }
//           ],
//         },
//       ],
//     },
//     { path: '/login', element: <Login /> },
//     { path: '/logout', element: <Logout /> },
//     { path: '*', element: <NotFound /> },
//   ]);
// };

// export default Routes;
import React, { lazy } from 'react';
import { Navigate, useRoutes } from 'react-router-dom';
import Login from '../../pages/auth/Login';
import Logout from '../../pages/auth/Logout';
import NotFound from '../../pages/not_found/NotFound';
import Home from '../../pages/globalWrapper/GlobalWrapper'; // This is the main layout

// --- Admin Dashboard Components ---
const AdminPagesWarper = lazy(() => import('../../pages/admin/PagesWarper'));
const AdminHome = lazy(() => import('../../pages/admin/home/AdminHome'));
const ResetWorkShops = lazy(() => import('../../pages/admin/resetWorkShops/ResetWorkShops'));
const ExportData = lazy(() => import('../../pages/admin/exportData/ExportData'));
const ImportData = lazy(() => import('../../pages/admin/importData/ImportData'));

// --- Workshop/User Components ---
const ServeAsthmaPagesWarper = lazy(() => import('../../pages/workshop/PagesWarper'));
const ServeAsthmaHome = lazy(() => import('../../pages/workshop/workshopHome/WorkshopHome'));
const WorkshopCore = lazy(() => import('../../pages/workshop/workshopCore/WorkshopCore'));

const Routes = () => {
  let currentPage = 'login';
  const strUser = localStorage.getItem('user');

  // Determine the current user state and role
  if (strUser) {
    try {
      const user = JSON.parse(strUser);
      currentPage = user?.is_admin ? 'admin' : 'home';
    } catch (error) {
      // Handle case where 'user' localStorage item is malformed
      console.error('Error parsing user data from localStorage:', error);
      currentPage = 'login';
    }
  }

  console.log('Current Page determined:', currentPage);

  return useRoutes([
    // --- 1. Authentication Routes ---
    { path: '/login', element: <Login /> },
    { path: '/logout', element: <Logout /> },

    // --- 2. Main Layout/Protected Routes ---
    {
      path: '/',
      // Render <Home /> (the main layout) if logged in, otherwise redirect to /login
      element: currentPage === 'login' ? <Navigate to="/login" replace /> : <Home />,
      children: [
        // CRITICAL FIX: Index Route for Root Path (/)
        // If logged in and hitting '/', redirect to the correct dashboard based on role.
        {
          path: '',
          element: <Navigate to={`/${currentPage}`} replace />,
        },

        // --- User/Workshop Routes ---
        {
          path: 'home',
          // Only allow access if the user's role is 'home', otherwise redirect to their actual page ('/admin')
          element:
            currentPage === 'home' ? (
              <ServeAsthmaPagesWarper />
            ) : (
              <Navigate to={`/${currentPage}`} replace />
            ),
          children: [
            { path: '', element: <ServeAsthmaHome /> },
            { path: 'workshop', element: <WorkshopCore /> },
          ],
        },

        // --- Admin Routes ---
        {
          path: 'admin',
          // Only allow access if the user's role is 'admin', otherwise redirect to their actual page ('/home')
          element:
            currentPage === 'admin' ? (
              <AdminPagesWarper />
            ) : (
              <Navigate to={`/${currentPage}`} replace />
            ),
          children: [
            { path: '', element: <AdminHome /> },
            { path: 'reset', element: <ResetWorkShops /> },
            { path: 'export', element: <ExportData /> },
            { path: 'import', element: <ImportData /> },
          ],
        },
      ],
    },

    // --- 3. 404 Not Found Route ---
    { path: '*', element: <NotFound /> },
  ]);
};

export default Routes;